import React from "react";
import { Tag } from "antd";

/**
 * Live preview of how the banner popup will appear on a mobile screen.
 * Rendered in the right column of BannerForm.
 */
function BannerPopupPreview({ title, imageUrl, linkUrl, linkType, displayTarget }) {
    return (
        <div className="sticky top-6">
            <p className="text-xs font-semibold text-content-3 uppercase tracking-wide mb-3">Xem trước popup</p>

            {/* Mobile frame */}
            <div
                className="relative mx-auto overflow-hidden rounded-2xl border-4 border-line-strong bg-surface-muted shadow-md"
                style={{ width: 220, height: 380 }}
            >
                {/* Fake background */}
                <div className="absolute inset-0 bg-gradient-to-b from-blue-100 to-purple-100" />

                {/* Overlay + popup card */}
                <div className="absolute inset-0 flex items-center justify-center bg-black/30 p-3">
                    <div className="w-full rounded-xl overflow-hidden bg-surface shadow-xl">
                        {/* Banner image */}
                        {imageUrl ? (
                            <img
                                src={imageUrl}
                                alt="preview"
                                className="w-full object-cover"
                                style={{ maxHeight: 130 }}
                            />
                        ) : (
                            <div
                                className="w-full flex items-center justify-center text-content-3 text-xs bg-surface-muted"
                                style={{ height: 90 }}
                            >
                                Chưa có ảnh
                            </div>
                        )}
                        {/* Content */}
                        <div className="p-2">
                            <p className="text-xs font-semibold text-content line-clamp-2">
                                {title || <span className="text-content-3">Tiêu đề banner</span>}
                            </p>
                            {linkUrl && (
                                <p className="text-xs text-blue-500 mt-1 truncate">{linkUrl}</p>
                            )}
                        </div>
                        {/* Actions */}
                        <div className="flex border-t border-line">
                            <div className="flex-1 py-2 text-center text-xs text-content-3">Đóng</div>
                            {linkUrl && (
                                <div className="flex-1 py-2 text-center text-xs text-blue-500 font-semibold border-l border-line">
                                    Xem ngay
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                {/* Top bar */}
                <div className="absolute top-0 left-0 right-0 flex items-center justify-center bg-gray-800/70 h-5">
                    <span className="text-white text-xs opacity-40">Preview</span>
                </div>
            </div>

            {/* Meta tags */}
            <div className="mt-3 flex flex-wrap gap-1 justify-center">
                {displayTarget && displayTarget !== "all" && (
                    <Tag color={displayTarget === "web" ? "green" : "orange"}>
                        {displayTarget === "web" ? "Web only" : "App only"}
                    </Tag>
                )}
                {linkType === "external" && <Tag color="red">External link</Tag>}
            </div>
        </div>
    );
}

export default BannerPopupPreview;
